export default () => {
  const nonce = document.querySelector('meta[name="csp-nonce"]')?.getAttribute('content');
  if (!nonce) return;

  // Восстанавливаем nonce на всех тегах, которые могли быть перерисованы
    document.querySelectorAll('script, style, link')
    .forEach(el => el.setAttribute('nonce', nonce));
}
